@if (isPro) {
  <div>
    <app-player-profile-statistics-filter (onFilterChanged)="filterChanged($event)"
                                          [showDeleteCheckbox]="true" (onShowDeleteChanged)="showDeleteChanged($event)"/>

    <app-loading [active]="isLoading && !pagedData" [center]="true"/>
    <app-message [active]="!!errorMsg" [message]="errorMsg"/>

    @if (!errorMsg && columns && pagedData) {
      <div id="divMatches">
        @if (filterLoaded) {
          <app-generic-list #genericList
                            class="frontend customPaging smart" [frontend]="true"

                            [columns]="columns" [columnsMobile]="columnsMobile"
                            [noDataMsg]="'TABLE_NO_DATA'"

                            [pagedData]="pagedData"
                            [pageSize]="paging.pageSize"
                            [pagingCustom]="true"
                            [showFooter]="true"
                            [footerRight]="footerRightTemplate"
                            (onLazyLoading)="lazyLoading($event)"

                            [mobileRowTemplate]="mobileRowTemplate"
                            [hideMobileRowButtonsColumn]="!showDeleteSelected"
                            [rowDelete]="showDeleteSelected" (onRowDelete)="rowDelete($event)"

                            [dataLoading]="isLoading || deletingStatistics"
                            [positionTop]="positionTop"
                            (onRowSelect)="onRowSelect($event)" [rowSelect]="true"
                            [showReload]="true" (onReload)="loadData()"
          />

          <ng-template #footerRightTemplate pTemplate="item">
            <div class="flex align-items-center pr-2">
              <div class="cursor-pointer accent-hover"
                   (click)="showDeleteSelected = !showDeleteSelected; showDeleteChanged(showDeleteSelected)">
                <i class="pi pi-trash" [class.accent]="showDeleteSelected"></i>
              </div>
            </div>
          </ng-template>
        }
      </div>
    }

    <ng-template #mobileRowTemplate let-item="data" pTemplate="item">
      <td>
        <div class="flex align-items-center gap-2">
          <div style="width: 60px">
            <ng-container [ngTemplateOutlet]="dateTemplate" [ngTemplateOutletContext]="{data: item}"/>
          </div>
          <div class="w-full">
            <!--<div class="flex align-items-center gap-2 text-gray-400 pb-0_5">
              <div>
                {{item.eventTypeCd | domainValuePipe: 'event-type'}}
              </div>
              @if (item.eventKindCd) {
                <div>
                  ({{item.eventKindCd | domainValuePipe: 'event-kind'}})
                </div>
              }
            </div>-->
            <div class="flex align-items-center gap-2 text-gray-400">
              <div>
                {{item.event?.name}}
              </div>
              @if (item.roundName) {
                <div>
                  -
                </div>
                <div>
                  {{item.roundName}}
                </div>
              }
            </div>
            @if (item.parentParticipant1Name && item.parentParticipant2Name) {
              <div class="flex align-items-center text-gray-400 text-xs">
                {{item.parentParticipant1Name}} - {{item.parentParticipant2Name}}
              </div>
            }
            <div class="w-full flex align-items-center gap-2 pt-1">
              <div class="flex-1">
                <div class="cell-nowrap pb-0_5" [class.green]="item.participant1Winner">{{item.participant1Name}}</div>
                <div class="cell-nowrap pt-0_5" [class.green]="item.participant2Winner">{{item.participant2Name}}</div>
              </div>
              <div>
                <div class="cell-nowrap pb-0_5" [class.green]="item.participant1Winner">{{item.result1}}</div>
                <div class="cell-nowrap pt-0_5" [class.green]="item.participant2Winner">{{item.result2}}</div>
              </div>
            </div>
          </div>
        </div>
      </td>
    </ng-template>

    <ng-template #dateTemplate let-item="data" pTemplate="item">
      <app-date-time-presenter [date]="item.date" [small]="true"/>
    </ng-template>

    <ng-template #eventInfoTemplate let-item="data" pTemplate="item">
      <div [class.w-6rem]="view.isMobile" [class.w-12rem]="!view.isMobile">
        <div class="cell-nowrap" [class.text-gray-400]="view.isMobile" [class.pb-0_5]="view.isMobile">
          {{item.event?.name}}
        </div>
        <div class="cell-nowrap text-gray-400" [class.pt-0_5]="view.isMobile">
          {{item.roundName}}
        </div>
      </div>
    </ng-template>

    <ng-template #participantsTemplate let-item="data" pTemplate="item">
      <div class="w-full flex align-items-center gap-1">
        <span [class.green]="item.participant1Winner" class="flex-1 text-right">
          {{item.participant1Name}}
        </span>
        <span>-</span>
        <span [class.green]="item.participant2Winner" class="flex-1">
          {{item.participant2Name}}
        </span>
      </div>
      @if (item.parentParticipant1Name && item.parentParticipant2Name) {
        <div class="w-full flex align-items-center gap-1 text-gray-400 text-sm">
          <span class="flex-1 text-right">
            ({{item.parentParticipant1Name}})
          </span>
          <span></span>
          <span class="flex-1">
            ({{item.parentParticipant2Name}})
          </span>
        </div>
      }
      <!--{{item.participants}}-->
    </ng-template>

    <ng-template #matchInfoTemplate let-item="data" pTemplate="item">
      <div>
        <div [class.text-gray-400]="view.isMobile" [class.pb-0_5]="view.isMobile">
          {{item.eventTypeCd | domainValuePipe: 'event-type'}}
        </div>
        <div class="text-gray-400" [class.pt-0_5]="view.isMobile">
          {{item.eventKindCd | domainValuePipe: 'event-kind'}}
        </div>
      </div>
      <!--
      <td class="text-center">{{event.eventTypeCd | domainValuePipe: 'event-type'}}</td>
          <td class="text-center">{{event.eventKindCd | domainValuePipe: 'event-kind'}}</td>
          <td class="text-center">{{event.dartTypeCd | domainValuePipe: 'dart-type'}}</td>-->
    </ng-template>
  </div>
} @else {
  <app-player-profile-pro-feature/>
}
